import { PredefinedUserZone, ZoneCompany } from '@saliente/common-auth';
import { addMonthsToYYYYYMM, dateToDDMMMMYYYYHHmmString, dateToYYYYMM, intYYYYMMDDToString, intYYYYMMToString, isNullOrUndefined, precisionRound } from '@saliente/library';
import {
	Billing_ClientChangeRequestProcessStatusRepresentation,
	Billing_ContractComputeRequestInput,
	Billing_ContractComputeResponseRepresentation,
	Billing_ContractDefinitionForUpdateStartingAtMonth,
	Billing_ContractTypeDefinitionRepresentation,
	Billing_GetClientContractDefinitionForUpdateStartingAtMonthUsingGetQuery,
	Billing_PromotionXClientRepresentation,
	Billing_SubscriptionInvoiceHistoryListRepresentation,
	Billing_SubscriptionInvoiceHistoryRepresentation,
} from 'src/app/common/services/subscription.service';

/*- export class ModelCardLine {
	data: Accounts_CreditCardRepresentation;
	expireDateEx: Date;
	initialize(card: Accounts_CreditCardRepresentation): void {
		this.data = card;
		this.expireDateEx = intToDate(parseInt(card.expirationDate.replace(/-/g,''), 10));
	}
}
 */
export class ModelLine {
	data: Billing_SubscriptionInvoiceHistoryRepresentation;
	/*null if :
    - passed data is null or undefined
    - not active
    - current month not in promotion range

  */
	promotionXClient: Billing_PromotionXClientRepresentation;
	invoiceMonthAsString: string;
	consumptionMonthAsString: string;
	invoiceValueColor: string;
	showInitializeEditContract = false;
	canSaveDecreasedValue: boolean; /*- lower values can be saved only starting with next month */
	currentContractModified: boolean; /*- the current contract is different than the one used to create the history entry */
	currentContractSubscriptionValue: number;

	initialize(crt: Billing_SubscriptionInvoiceHistoryRepresentation, promotionXClient: Billing_PromotionXClientRepresentation, showContractEditButtons: boolean): void {
		this.data = crt;
		this.promotionXClient = null;
		if (promotionXClient ?? null !== null) {
			if (promotionXClient.isActive === true) {
				const promotionLatMonth = addMonthsToYYYYYMM(promotionXClient.startMonth, promotionXClient.promotionCode.promotionDefinition.numMonths - 1);
				if (crt.forSubscriptionMonth >= promotionXClient.startMonth && crt.forSubscriptionMonth <= promotionLatMonth) {
					this.promotionXClient = promotionXClient;
				}
			}
		}
		this.currentContractModified = crt.contractSubscription.externalId !== crt.contractCurrent.externalId;
		this.currentContractSubscriptionValue = crt.contractCurrent.price + crt.contractCurrent.priceDelta; //  + crt.contractCurrent.vatDelta;

		const thisMonth = dateToYYYYMM(new Date());
		//const prevMonth = addMonthsToYYYYYMM(thisMonth, -1);
		const nextMonth = addMonthsToYYYYYMM(thisMonth, 1);
		//this.showInitializeEditContract = showContractEditButtons && crt.forSubscriptionMonth >= prevMonth && crt.forSubscriptionMonth <= nextMonth;
		/*- we will show the resolve button only for nextMonth only if the estimated invoice amount is greater than the subscription value */

		this.showInitializeEditContract = showContractEditButtons && crt.forSubscriptionMonth === nextMonth && crt.totalPriceExtra > 0;
		this.canSaveDecreasedValue = crt.forSubscriptionMonth === nextMonth;

		const consumptionMonth = addMonthsToYYYYYMM(crt.forSubscriptionMonth, -2);
		this.invoiceMonthAsString = intYYYYMMToString(crt.forSubscriptionMonth, 'ro-ro');
		this.consumptionMonthAsString = intYYYYMMToString(consumptionMonth, 'ro-ro');
		if (thisMonth < crt.forSubscriptionMonth) {
			/*- estimate or service start date in future*/
			if (crt.isPaid) {
				this.invoiceValueColor = 'lightgreen';
			} else {
				this.invoiceValueColor = 'lightblue';
			}
		} else {
			if (crt.isPaid) {
				this.invoiceValueColor = 'lightgreen';
			} else {
				this.invoiceValueColor = 'pink';
			}
		}
	}
}
export class EditContractModelDefinition {
	data: Billing_ContractTypeDefinitionRepresentation;
	line: ModelLine;
	variables: Billing_ContractComputeRequestInput;
	computeResult: Billing_ContractComputeResponseRepresentation;
	actualContractSubscriptionValue: number;
	canSave: boolean;
	subscriptionDiff = 0;
	estimatedValue: number;
	showEstimates: boolean;
	isShown = false; /* shown in caroussel active items */
	initialize(data: Billing_ContractTypeDefinitionRepresentation, actualContractSubscriptionValue: number, line: ModelLine, estimatedValue: number, showEstimates: boolean): void {
		this.data = data;
		this.line = line;
		this.estimatedValue = estimatedValue;
		this.showEstimates = showEstimates;
		this.actualContractSubscriptionValue = actualContractSubscriptionValue;
		this.variables = {
			/*-
			docsNum: data.docsNumIncluded,
			empsNum: contract.contractType.code === data.contractType.code ? Math.max(contract.empsNumIncluded, data.empsNumIncluded) : data.empsNumIncluded,
			impsNum: data.impsNumIncluded,
      */
			docsNum: data.docsNumIncluded,
			empsNum: data.empsNumIncluded,
			impsNum: data.impsNumIncluded,
		};
	}
	updateComputeResult(computeResult: Billing_ContractComputeResponseRepresentation): void {
		this.computeResult = computeResult;
		this.subscriptionDiff = precisionRound(computeResult.computedPriceEnrollmentWithoutPromotion - this.actualContractSubscriptionValue, 2);
		this.canSave = this.line.canSaveDecreasedValue || this.subscriptionDiff > 0;
	}
	setIsShown(isShown: boolean): void {
		this.isShown = isShown;
	}
}
export class EditContractModel {
	data: Billing_ContractDefinitionForUpdateStartingAtMonth;
	line: ModelLine;
	contractDefinitions: EditContractModelDefinition[];
	selectedContractDefinition: EditContractModelDefinition;
	/*----- navigation info -----*/
	showNavigationLeft: boolean;
	showNavigationRight: boolean;
	defaultDefinitionfound = false;
	crtLeftDefinitionIndex = 0; /* mark that we have'nt found yet the default value to be highlited */
	numDefinitionsShown = 4;
	/*----- ^^^^^^^^^^^^^^^ -----*/

	initialize(data: Billing_ContractDefinitionForUpdateStartingAtMonth, line: ModelLine, showEstimates: boolean): void {
		this.data = data;
		this.line = line;
		this.contractDefinitions = [];
		let idx = 0;
		data.definitions.definitions.forEach((definition) => {
			const editContractModelDefinition = new EditContractModelDefinition();
			let estimatedValue: number;
			for (const estimatedComputeResult of data.estimatedComputeResults) {
				if (estimatedComputeResult.contractType === definition.contractType.code) {
					estimatedValue = estimatedComputeResult.ontractComputeResponse.computedPriceEnrollmentWithoutPromotion;
					break;
				}
			}
			editContractModelDefinition.initialize(definition, data.subscriptionPrice, line, estimatedValue, showEstimates);
			this.contractDefinitions.push(editContractModelDefinition);
			if (data.contract.contractType.code === definition.contractType.code) {
				/*- actual type selected by default*/
				this.selectedContractDefinition = editContractModelDefinition;
				this.crtLeftDefinitionIndex = idx;
				this.defaultDefinitionfound = true;
			}
			editContractModelDefinition.setIsShown(
				(this.defaultDefinitionfound && idx >= this.crtLeftDefinitionIndex && idx < this.crtLeftDefinitionIndex + this.numDefinitionsShown) ||
					(!this.defaultDefinitionfound && idx > data.definitions.definitions.length - this.numDefinitionsShown - 1)
			);
			idx += 1;
		});
		this.computeShowNavigationXXX();
	}
	computeShowNavigationXXX(): void {
		this.showNavigationLeft = this.crtLeftDefinitionIndex !== 0;
		this.showNavigationRight = this.crtLeftDefinitionIndex + this.numDefinitionsShown < this.contractDefinitions.length;
	}
	navigateLeft(): void {
		if (this.crtLeftDefinitionIndex > 0) {
			this.crtLeftDefinitionIndex += -1;
			this.contractDefinitions[this.crtLeftDefinitionIndex].setIsShown(true);
			this.contractDefinitions[this.crtLeftDefinitionIndex + this.numDefinitionsShown].setIsShown(false);
			this.computeShowNavigationXXX();
		}
	}
	navigateRight(): void {
		if (this.crtLeftDefinitionIndex + this.numDefinitionsShown < this.contractDefinitions.length) {
			this.contractDefinitions[this.crtLeftDefinitionIndex].setIsShown(false);
			this.contractDefinitions[this.crtLeftDefinitionIndex + this.numDefinitionsShown].setIsShown(true);
			this.crtLeftDefinitionIndex += 1;
			this.computeShowNavigationXXX();
		}
	}
}
export class Model {
	CancellationTypeCancellation = 'CANCELLATION';
	CancellationTypeDissolution = 'DISSOLUTION';
	CancellationTypeChangeExpert = 'CHANGE_EXPERT';

	data: Billing_SubscriptionInvoiceHistoryListRepresentation;
	client: ZoneCompany;
	lines: ModelLine[] = [];
	contractInEdit: EditContractModel; /*- for edit dialog*/
	showContractEditDialog = false;
	showContractEditButtons: boolean;
	isZeus: boolean;
	selectedZoneCode: string;
	isClientZone: boolean;
	thisMonth: number;
	prevMonth: number;
	nextMonth: number;
	showChangeSubscriptionForNextMonth = false; // show the edit contract button for next month

	clientChangeRequestActive = false;
	showCancellationDialog = false;
	/*- radio button selected choice */
	cancellationType = this.CancellationTypeCancellation;
	cancellationDialogTitle = '';
	//cancellationMessage = '';
	showChangeExpertDialog = false;

	/*- cancellation info related fields */
	//platformaAvailableTillDayMessage: string;

	cancellationTypeInfo: string;
	momentCancellationInitiated: Date;
	momentCancellationInitiatedAsString: string;
	cancellationAccepted: boolean;
	platformaAvailableTillDayDateAsString: string;
	lastAccountingMonthAsString: string;
	lastInvoiceableMonthAsString: string;
	momentCancellationAcceptedAsString: string;
	/*- since momentAccepted was added in database later we might have for a while null values so do not show this line (if null)*/
	showLastInvoiceableMonth = false;
	/*---------------cards------------------------*/
	/*- cards: ModelCardLine[]; */
	showDates = true; /*if we have cancellation && isDuringTakeover we will not show lastAccountingMonth and lastInvoiceableMonth*/

	targetDecommissionFromSuspensionDateAsString: string;

	updateCancellation(clientChangeRequestProcessStatusRepresentation: Billing_ClientChangeRequestProcessStatusRepresentation): void {
		/*- we might come from subscription.component.initiateCancellation() so initialize the model */
		this.data.clientChangeRequestProcessStatusRepresentation = clientChangeRequestProcessStatusRepresentation;
		this.cancellationTypeInfo = null;
		this.clientChangeRequestActive = false;
		if (!isNullOrUndefined(clientChangeRequestProcessStatusRepresentation)) {
      		/*- normally we will have all three types of canncelation null */
			if (clientChangeRequestProcessStatusRepresentation.cancellationProcess !== null) {
        		this.clientChangeRequestActive = true;
				this.showDates = !clientChangeRequestProcessStatusRepresentation.cancellationProcess.isDuringTakeover;
				this.cancellationTypeInfo = this.CancellationTypeCancellation;
				this.momentCancellationInitiated = new Date(Date.parse(clientChangeRequestProcessStatusRepresentation.cancellationProcess.momentCreated));
				this.momentCancellationInitiatedAsString = dateToDDMMMMYYYYHHmmString(this.momentCancellationInitiated, 'ro-ro');
				this.cancellationAccepted = false;
				if (!isNullOrUndefined(clientChangeRequestProcessStatusRepresentation.cancellationProcess.platformAvailableTillDay)) {
					this.cancellationAccepted = true;
					this.platformaAvailableTillDayDateAsString = intYYYYMMDDToString(clientChangeRequestProcessStatusRepresentation.cancellationProcess.platformAvailableTillDay, 'ro-ro');
					this.lastAccountingMonthAsString = intYYYYMMToString(clientChangeRequestProcessStatusRepresentation.cancellationProcess.lastAccountingMonth, 'ro-ro');
					/*- till old processes are completed momentAccepted might be null since it was added later*/
					this.showLastInvoiceableMonth = !isNullOrUndefined(clientChangeRequestProcessStatusRepresentation.cancellationProcess.momentAccepted);
					/*- compute it anyway using momentCreated if momentAccepted is null; shoiuld be removed in the future*/
					const ma = !isNullOrUndefined(clientChangeRequestProcessStatusRepresentation.cancellationProcess.momentAccepted)
						? clientChangeRequestProcessStatusRepresentation.cancellationProcess.momentAccepted
						: clientChangeRequestProcessStatusRepresentation.cancellationProcess.momentCreated;
					const momentCancellationAccepted = new Date(Date.parse(ma));
					this.momentCancellationAcceptedAsString = dateToDDMMMMYYYYHHmmString(momentCancellationAccepted, 'ro-ro');
					const monthCancellationAccepted = dateToYYYYMM(momentCancellationAccepted);
					const lastInvoiceableMonth =
						monthCancellationAccepted > clientChangeRequestProcessStatusRepresentation.cancellationProcess.lastAccountingMonth
							? monthCancellationAccepted
							: clientChangeRequestProcessStatusRepresentation.cancellationProcess.lastAccountingMonth;
					this.lastInvoiceableMonthAsString = intYYYYMMToString(lastInvoiceableMonth, 'ro-ro');
				}
			}
			if (clientChangeRequestProcessStatusRepresentation.dissolutionProcess !== null) {
        		this.clientChangeRequestActive = true;
				this.cancellationTypeInfo = this.CancellationTypeDissolution;
				this.momentCancellationInitiated = new Date(Date.parse(clientChangeRequestProcessStatusRepresentation.dissolutionProcess.momentCreated));
				this.momentCancellationInitiatedAsString = dateToDDMMMMYYYYHHmmString(this.momentCancellationInitiated, 'ro-ro');
				this.cancellationAccepted = false;
				/*- this is different from cancellation,  platformAvailableTillDay will be set when the client in marked dissoluted not at Accept*/
				if (!isNullOrUndefined(clientChangeRequestProcessStatusRepresentation.dissolutionProcess.lastAccountingMonth)) {
					this.cancellationAccepted = true;
					this.platformaAvailableTillDayDateAsString = !isNullOrUndefined(clientChangeRequestProcessStatusRepresentation.dissolutionProcess.platformAvailableTillDay)
						? intYYYYMMDDToString(clientChangeRequestProcessStatusRepresentation.dissolutionProcess.platformAvailableTillDay, 'ro-ro')
						: '-';
					this.lastAccountingMonthAsString = intYYYYMMToString(clientChangeRequestProcessStatusRepresentation.dissolutionProcess.lastAccountingMonth, 'ro-ro');
					/*- till old processes are completed momentAccepted might be null since it was added later*/
					this.showLastInvoiceableMonth = !isNullOrUndefined(clientChangeRequestProcessStatusRepresentation.dissolutionProcess.momentAccepted);
					/*- compute it anyway using momentCreated if momentAccepted is null; shoiuld be removed in the future*/
					const ma = !isNullOrUndefined(clientChangeRequestProcessStatusRepresentation.dissolutionProcess.momentAccepted)
						? clientChangeRequestProcessStatusRepresentation.dissolutionProcess.momentAccepted
						: clientChangeRequestProcessStatusRepresentation.dissolutionProcess.momentCreated;
					const momentCancellationAccepted = new Date(Date.parse(ma));
					this.momentCancellationAcceptedAsString = dateToDDMMMMYYYYHHmmString(momentCancellationAccepted, 'ro-ro');
					const monthCancellationAccepted = dateToYYYYMM(momentCancellationAccepted);
					const lastInvoiceableMonth =
						monthCancellationAccepted > clientChangeRequestProcessStatusRepresentation.dissolutionProcess.lastAccountingMonth
							? monthCancellationAccepted
							: clientChangeRequestProcessStatusRepresentation.dissolutionProcess.lastAccountingMonth;
					this.lastInvoiceableMonthAsString = intYYYYMMToString(lastInvoiceableMonth, 'ro-ro');
				}
			}
			if (clientChangeRequestProcessStatusRepresentation.expertChangeProcess !== null) {
        		this.clientChangeRequestActive = true;
				this.cancellationTypeInfo = this.CancellationTypeChangeExpert;
			}
			/*-
			if (clientChangeRequestProcessStatusRepresentation.cancellationProcess !== null) {
				if (!isNullOrUndefined(clientChangeRequestProcessStatusRepresentation.cancellationProcess.platformAvailableTillDay)) {
					this.platformaAvailableTillDayMessage = ' Ultima zi in care platforma va fi accesibila este: ';
					this.platformaAvailableTillDayDateAsString = intYYYYMMDDToString(clientChangeRequestProcessStatusRepresentation.cancellationProcess.platformAvailableTillDay, 'ro-ro');
				}
				if (clientChangeRequestProcessStatusRepresentation.cancellationProcess.type === 'InitiatedByClient') {
					this.cancellationMessage = 'Procesul de reziliere (mutare alt contabil) este in desfasurare.';
				} else {
					// InitiatedBySuspended or InitiatedByLimitedResurrection
					this.cancellationMessage = '';
				}
			} else {
				if (!isNullOrUndefined(clientChangeRequestProcessStatusRepresentation.dissolutionProcess.platformAvailableTillDay)) {
					this.platformaAvailableTillDayMessage = ' Ultima zi in care platforma va fi accesibila este: ';
					this.platformaAvailableTillDayDateAsString = intYYYYMMDDToString(clientChangeRequestProcessStatusRepresentation.dissolutionProcess.platformAvailableTillDay, 'ro-ro');
				}

				this.cancellationMessage = 'Procesul de reziliere (lichidare) este in desfasurare.';
			}
      */
		}
	}
	initialize(result: Billing_SubscriptionInvoiceHistoryListRepresentation, showContractEditButtons: boolean, isZeus: boolean, selectedZoneCode: string): void {
		this.data = result;
		this.selectedZoneCode = selectedZoneCode;
		this.isClientZone = selectedZoneCode === PredefinedUserZone.Administrator;
		this.updateCancellation(result.clientChangeRequestProcessStatusRepresentation);

		this.lines = [];

		this.thisMonth = dateToYYYYMM(new Date());
		this.prevMonth = addMonthsToYYYYYMM(this.thisMonth, -1);
		this.nextMonth = addMonthsToYYYYYMM(this.thisMonth, 1);

		this.showContractEditButtons = showContractEditButtons;
		this.isZeus = isZeus; /*- will show estimates; the client will not see this info. */
		if (result.isSuspended) {
			this.targetDecommissionFromSuspensionDateAsString = intYYYYMMDDToString(result.targetDecommissionFromSuspensionDate, 'ro-ro');
		}
		result.list.forEach((crt) => {
			if (crt.forSubscriptionMonth === this.nextMonth && showContractEditButtons === true) {
				this.showChangeSubscriptionForNextMonth = true;
			}

			const line = new ModelLine();
			line.initialize(crt, result.promotionXClient, showContractEditButtons);
			this.lines.push(line);
		});
	}
	getModelLine(month: number): ModelLine {
		let ret: ModelLine;
		for (const lineCrt of this.lines) {
			if (lineCrt.data.forSubscriptionMonth === month) {
				ret = lineCrt;
			}
		}
		return ret;
	}
	/*- actually not used any more in this functionality (list of cards not shown)
	initializeCreditCards(creditCards: Accounts_CreditCardRepresentation[]): void {
		this.cards = [];
		creditCards.forEach((card) => {
			const cardLine = new ModelCardLine();
			cardLine.initialize(card);
			this.cards.push(cardLine);
		});
	}
 */
	initializeEditContract(result: Billing_GetClientContractDefinitionForUpdateStartingAtMonthUsingGetQuery, line: ModelLine): void {
		this.contractInEdit = new EditContractModel();
		this.contractInEdit.initialize(result.billing.getClientContractDefinitionForUpdateStartingAtMonthUsingGET, line, this.isZeus);
	}
	public priceIntPart(price: number): number {
		return Math.floor(price);
	}

	public priceDecimalsPart(price: number): number {
		return precisionRound((price - Math.floor(price)) * 100, 0);
	}

	public priceDecimalsPartString(price: number): string {
		return String(this.priceDecimalsPart(price)).padStart(2, '0');
	}

	public initializeCancellationDialog(): void {
		this.cancellationType = this.CancellationTypeCancellation;
		this.updateCancellationType();
		this.showCancellationDialog = true;
	}
	public initializeDissolutionDialog(): void {
		this.cancellationType = this.CancellationTypeDissolution;
		this.updateCancellationType();
		this.showCancellationDialog = true;
	}
	public closeCancellationDialog(): void {
		this.showCancellationDialog = false;
	}
	public onUpdateCancelationType(event: any): void {
		this.updateCancellationType();
	}

	private updateCancellationType(): void {
		switch (this.cancellationType) {
			case this.CancellationTypeCancellation:
				this.cancellationDialogTitle = 'Reziliere contract';
				break;
			case this.CancellationTypeDissolution:
				this.cancellationDialogTitle = 'Închide/suspendă/radiază firma';
				break;
		}
	}

	public initializeChangeExpertDialog(): void {
		this.showChangeExpertDialog = true;
	}

	public closeChangeExpertDialog(): void {
		this.showChangeExpertDialog = false;
	}

	public closeContractEditDialog(): void {
		this.showContractEditDialog = false;
	}
}
